import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Info({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Info.Outline {...props} /> : <Info.Solid {...props} />;
}

Info.Outline = function Outline({ name, strokeWidth, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M12 17.0461C11.5858 17.0461 11.25 16.7104 11.25 16.2961V11.8771C11.25 11.4629 11.5858 11.1271 12 11.1271C12.4142 11.1271 12.75 11.4629 12.75 11.8771V16.2961C12.75 16.7104 12.4142 17.0461 12 17.0461Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={strokeWidth?.toString() ?? "0.5"}
        />
        <path
          d="M12.0002 9.7041C12.5525 9.7041 13.0002 9.25639 13.0002 8.7041C13.0002 8.15182 12.5525 7.7041 12.0002 7.7041H11.9902C11.438 7.7041 10.9902 8.15182 10.9902 8.7041C10.9902 9.25639 11.438 9.7041 11.9902 9.7041H12.0002Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={strokeWidth?.toString() ?? "0.5"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 12C2 6.47679 6.47679 2 12 2C17.5222 2 22 6.47673 22 12C22 17.5222 17.5222 22 12 22C6.47673 22 2 17.5222 2 12ZM12 3.5C7.30521 3.5 3.5 7.30521 3.5 12C3.5 16.6938 7.30527 20.5 12 20.5C16.6938 20.5 20.5 16.6938 20.5 12C20.5 7.30527 16.6938 3.5 12 3.5Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={strokeWidth?.toString() ?? "0.5"}
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Info.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        {/* Solid circle background */}
        <circle cx="12" cy="12" r="10" className="icon-secondary" />
        {/* "i" symbol - dot on top */}
        <circle cx="12" cy="8" r="1.25" className="icon-primary" />
        {/* "i" symbol - vertical line */}
        <rect
          x="11"
          y="10.5"
          width="2"
          height="6"
          rx="1"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
